<ng-progress [spinner]="false" [color]="'#7ab655'"></ng-progress>

<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="!finish">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p id="loadingText">Loading, please wait...</p>
                    </div>
                </ng-container>

                <div *ngIf="finish" class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <div>
                        <!--<h1 class="h3 mb-0 text-gray-800" style="margin-top: 3px;">{{client}}</h1>-->
                        <div class="breadcrumbs">
                            <span [routerLink]="['/app/clients']">Manage Clients</span> > 
                            <span (click)="backTo()">{{client}}</span> > 
                            <span *ngIf="showGenerateResults; else showConversionRateElse;" class="active">Results</span>
                            <ng-template #showConversionRateElse>
                                <span class="active">Conversion Rate</span>
                            </ng-template>
                        </div>

                        <div class="pRelative" style="margin-top: 14px;">
                            <!--<p style="line-height:0">{{niche}} - Regular - 2.0</p>-->
                            <p style="line-height:0;display: contents;">{{assessmentName}}</p>
                            <p [ngClass]="{'opacity0': !showGenerateResults}" style="margin-bottom: 4px;">Completed on: {{completedOn}}</p>
                            <div *ngIf="reportGenerated">
                                <div class="checkbox" style="display: contents;">
                                    <input id="checkbox" type="checkbox" [(ngModel)]="canSeeResults" (change)="markCheckBox()"> <!--[(ngModel)]="accept" (change)="acceptInstructions()"-->
                                    <label style="vertical-align: middle;" for="checkbox"></label>
                                </div>
                                <p style="display: contents;"><b>Share results with Client (Not Answers)</b></p>
                            </div>
                            <div *ngIf="reportGenerated && is360">
                                <div class="checkbox" style="display: contents;">
                                    <input id="checkbox-reminder" type="checkbox" [(ngModel)]="sendReminderEmails" (click)="sendReminderEmailChange($event)" [disabled]="!checkBoxReminderEnabled"> <!--[(ngModel)]="accept" (change)="acceptInstructions()"-->
                                    <label style="vertical-align: middle;" for="checkbox-reminder"></label>
                                </div>
                                <p style="display: contents;"><b>Send reminder emails</b></p>
                            </div>
                            <!--<ng-template #messageText>
            <p style="display: contents; color: red;"><b>Results will be available when the assessment meets raters completion criteria</b></p>
        </ng-template>-->
                        </div>
                    </div>

                    <div class="btns-container" style="margin-top:-58px;position: relative;">

                        <!--<div *ngIf="!reportGenerated">
                            <a *ngIf="currentTabSelected == 2 || currentTabSelected == 3" (click)="showImportModal()" class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm margin-right-5">
                                <i class="fas fa-file-import text-white-50"> <span class="button-text"> Import raters</span></i>
                            </a>
                        </div>-->

                        <div *ngIf="is360"> <!--*ngIf="!reportGenerated"-->
                            <a (click)="sendReminderEmailtoRaters()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5"> <!--*ngIf="currentTabSelected == 2 || currentTabSelected == 3"-->
                                <i class="fas fa-envelope text-white-50"> <span class="button-text">Send Reminders</span></i>
                            </a>
                        </div>

                        <div *ngIf="is360"> <!--*ngIf="!reportGenerated"-->
                            <a (click)="showRatersModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5"> <!--*ngIf="currentTabSelected == 2 || currentTabSelected == 3"-->
                                <i class="fas fa-edit text-white-50"> <span class="button-text"> Manage Raters</span></i>
                            </a>
                        </div>

                        <div *ngIf="is360 && currentTabSelected == 4">
                            <a (click)="exporRaterComments()" data-toggle="dropdown" class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm margin-right-5">
                                <i class="fas fa-file-export text-white-50"> <span class="button-text">Export</span></i>
                            </a>
                        </div>

                        <div *ngIf="showDownloadFromAssignedAssessment" class="position-relative">
                            <a data-toggle="dropdown" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-download text-white-50"> <span class="button-text">Download Reports</span></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li (click)="downloadAssessmentByUserType(3)">
                                    <a>
                                        <i class="material-icons custom-icons">file_download</i>
                                        <span> Client</span>
                                    </a>
                                </li>
                                <li (click)="downloadAssessmentByUserType(2)">
                                    <a>
                                        <i class="material-icons custom-icons">file_download</i>
                                        <span> Coach</span>
                                    </a>
                                </li>
                            </ul>
                        </div>


                        <div *ngIf="is360 && reportGenerated" class="position-relative">
                            <a data-toggle="dropdown" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-download text-white-50"> <span class="button-text">Download Reports</span></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li (click)="downloadAssessmentByUserType(3)">
                                    <a>
                                        <i class="material-icons custom-icons">file_download</i>
                                        <span> Client</span>
                                    </a>
                                </li>
                                <li (click)="downloadAssessmentByUserType(2)">
                                    <a>
                                        <i class="material-icons custom-icons">file_download</i>
                                        <span> Coach</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        
                        
                        <div *ngIf="!is360">
                            <a data-toggle="dropdown" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-download text-white-50"> <span class="button-text">Download Reports</span></i>
                            </a>
                            <ul  class="dropdown-menu">
                                <li (click)="downloadAssessmentByUserType(3)">
                                    <a>
                                        <i class="material-icons custom-icons">file_download</i>
                                        <span> Client</span>
                                    </a>
                                </li>
                                <li (click)="downloadAssessmentByUserType(2)">
                                    <a>
                                        <i class="material-icons custom-icons">file_download</i>
                                        <span> Coach</span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <ng-container *ngIf="showGenerateResults">
                            <a *ngIf="is360 && !reportGenerated" (click)="showConfirmationGenerateReportModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-download text-white-50"> <span class="button-text">Generate Results</span></i>
                            </a>
                        </ng-container>
                        

                        <!--<a *ngIf="is360 && reportGenerated" (click)="download()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                            <i class="fas fa-download text-white-50"> <span class="button-text">Download</span></i>
                        </a>-->
                    </div>
                </div>

                <!--<div class="card shadow" *ngIf="finish">-->
                <!--<div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12">
                            {{niche}} - Regular - 2.0
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>Completed on: {{completedOn}}</p>
                        </div>
                    </div>

                </div>-->
                <!--<div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <span>Client can see results</span>
                                <div class="checkbox" style="display: contents;">
                                    <input id="checkbox" type="checkbox"> [(ngModel)]="accept" (change)="acceptInstructions()"
                                    <label style="vertical-align: middle;" for="checkbox"></label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>-->

            <div class="topSpacing" *ngIf="finish">
                <div>
                    <ul class="tab-nav">
                        <li *ngIf="reportGenerated || !is360;" (click)="tabSelect(0)" [ngClass]="{'active': reportGenerated || !is360}"><a data-toggle="tab" href="#Tab1">Results</a></li>
                        <li *ngIf="reportGenerated || !is360;" (click)="tabSelect(1)"><a data-toggle="tab" href="#Tab2">Answers</a></li>
                        <li *ngIf="is360" (click)="tabSelect(2)" [ngClass]="{'active': !reportGenerated}"><a data-toggle="tab" href="#Tab3">Raters</a></li>
                        <li *ngIf="is360" (click)="tabSelect(3)"><a data-toggle="tab" href="#Tab4">Raters Conversion Rate</a></li>
                        <ng-container *ngIf="is360">
                            <li *ngIf="reportGenerated" (click)="tabSelect(4)"><a data-toggle="tab" href="#Tab5">Comments</a></li>
                        </ng-container>
                    </ul>
                </div>

                <div class="main-tab-content tab-content">
                    <div id="Tab1" class="tab-pane fade" [ngClass]="{'in': reportGenerated || !is360, 'active': reportGenerated || !is360}">

                        <p class="graphicTitle">Your Energetic Profile </p>
                        <!--<i [popover]="ep" class="fas fa-question-circle pointer"></i>
                        <popover-content #ep
                                         title="Energetic Profile"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>This chart shows your current status for each energy level.</p>
                        </popover-content>-->
                        <div class="row">
                            <!--graphic-->
                            <div class="col-md-9 images">
                                <div class="graphics">
                                    <div style="display: block">
                                        <!--<p class="graphicTitle">{{graphicTitle1}}</p>-->
                                        <!--<p class="graphicTitle">Your Energetic Profile</p>-->

                                        <div class="graphicsValues" style="position:relative;">
                                            <div>
                                                <p *ngFor="let level of levels1; let i = index;" class="display level{{7-i}}">Level {{7 - i}}</p>
                                                <span *ngFor="let level of levels1; let i = index;" class="display level{{7-i}}">{{level}}%</span>
                                            </div>
                                            <span *ngFor="let level of levels1; let i = index;" class="display level{{7-i}}">{{level}}%</span>
                                            <canvas baseChart
                                                    [datasets]="ERGraphicDatasets"
                                                    [labels]="ERGraphicLabel"
                                                    [options]="ERGraphicOptions"
                                                    [legend]="ERGraphicLegend"
                                                    [chartType]="ERGraphicChartType"
                                                    [colors]="colors"></canvas>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />

                        <p class="graphicTitle">Your Energetic Stress Reaction </p>
                        <!--<i [popover]="esr" class="fas fa-question-circle pointer"></i>
                        <popover-content #esr
                                         title="Energetic Stress Reaction"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>This chart shows how you react under stress conditions according to your energy levels.</p>
                        </popover-content>-->
                        <div class="row">
                            <div class="col-md-9 images">
                                <div class="graphics">
                                    <div style="display: block">
                                        <!--<p class="graphicTitle">{{graphicTitle2}}</p>-->
                                        <!--<p class="graphicTitle">Your Energetic Stress Reaction</p>-->

                                        <div class="graphicsValues" style="position:relative;">
                                            <div>
                                                <p *ngFor="let level of levels2; let i = index;" class="display level{{7-i}}">Level {{7 - i}}</p>
                                                <span *ngFor="let level of levels2; let i = index;" class="display level{{7-i}}">{{level}}%</span>
                                            </div>
                                            <span *ngFor="let level of levels2; let i = index;" class="display level{{7-i}}">{{level}}%</span>
                                            <canvas baseChart
                                                    [datasets]="ERPGraphicDatasets"
                                                    [labels]="ERPGraphicLabel"
                                                    [options]="ERPGraphicOptions"
                                                    [legend]="ERPGraphicLegend"
                                                    [chartType]="ERPGraphicChartType"
                                                    [colors]="colors"></canvas>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />

                        <div class="row">
                            <div class="col-md-12">
                                <div class="container-fluid ">
                                    <!--Bug 2170: ELI staging version is not showing the ARL at the Assessment results pages (at both Coach and Client modes)// remove codition showGenerateResults -->
                                    <p class="subTitle" style="font-weight:bold;">
                                        Your Average Resonating Level of Energy (ARL) is :
                                        <span class="alv"> {{ARL.Values[0].Value}} </span>
                                    </p>
                                    <!--<i [popover]="arl" class="fas fa-question-circle pointer"></i>
                                    <popover-content #arl
                                                        title="ARL"
                                                        placement="right"
                                                        [animation]="true"
                                                        [closeOnClickOutside]="true">
                                        <p>This number represents your ability to...</p>
                                    </popover-content>-->
                                </div>
                            </div>
                        </div>

                        <br />

                        <div *ngIf="is360" class="container-fluid">
                            <!--section1 360-->
                            <div>
                                <p><b>Your ability to:</b></p>
                                <p><b>(1=very poor,2=below to average,3=average,4=above average,5=excellent)</b></p>
                                <ng-container *ngFor="let question of questions360_1; let i = index;">
                                    <div class="row">
                                        <div class="flexbox-container">
                                            <div class="col-xs-12 col-md-3 align">
                                                <p class="graphicTitle">{{question[0]}}</p>
                                            </div>


                                            <div class="col-xs-12 col-md-4 images">
                                                <canvas baseChart
                                                        [datasets]="question[1]"
                                                        [labels]="question[2]"
                                                        [options]="graphic360_1_1_Options"
                                                        [legend]="false"
                                                        chartType="horizontalBar"
                                                        [colors]="colors360"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </div>

                            <!--section2 360-->
                            <div>
                                <p><b>The extent to which you appear to:</b></p>
                                <p><b>(1=never; 2=rarely; 3=sometimes; 4=usually; 5=always)</b></p>
                                <ng-container *ngFor="let question of questions360_2; let i = index;">
                                    <div class="row">
                                        <div class="flexbox-container">
                                            <div class="col-md-3 text-right">
                                                <p class="graphicTitle">{{question[0]}}</p>
                                            </div>


                                            <div class="col-md-4 images">
                                                <canvas baseChart
                                                        [datasets]="question[1]"
                                                        [labels]="question[2]"
                                                        [options]="graphic360_1_1_Options"
                                                        [legend]="false"
                                                        chartType="horizontalBar"
                                                        [colors]="colors360"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </div>

                        </div>

                        <!--<div>
                            <ul class="nav nav-tabs">
                                <li class="active"><a data-toggle="tab" href="#graphic1">Your Energetic Profile</a></li>
                                <li><a data-toggle="tab" href="#graphic2">Your Energetic Stress Reaction</a></li>
                                <li *ngIf="is360"><a data-toggle="tab" href="#360Graphics">Your Leadership Competencies</a></li>
                            </ul>
                        </div>

                        <div class="tab-content">
                            <div id="graphic1" class="tab-pane fade in active">

                            </div>

                            <div id="graphic2" class="tab-pane fade">

                            </div>

                            <div *ngIf="is360" id="360Graphics" class="tab-pane fade">

                            </div>

                        </div>-->
                    </div>

                    <div id="Tab2" class="tab-pane fade">
                        <div>
                            <br />

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="container-fluid">
                                        <p style="margin-bottom:-15px;" class="negativelyKeyed">Note: Questions displayed in red are "negatively keyed," indicating that the response scale is reversed</p>
                                    </div>
                                </div>
                            </div>

                            <div *ngFor="let section of assessmentAnswers; let i = index;">

                                <ng-container *ngIf="section.SectionId == 2" class="row">
                                    <div class="col-md-12">
                                        <div class="container-fluid noPadding">
                                            <h4>Satisfaction Answers</h4>
                                        </div>
                                    </div>
                                </ng-container>



                                <div class="row answerLevels" *ngFor="let answer of section.Answers ">

                                    <ng-container *ngIf="section.SectionId == 1">
                                        <div class=" level{{answer.Level}}">
                                            <div class="col-md-12">
                                                <div class="container-fluid">
                                                    <h4>Level {{answer.Level}}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <!--<ng-container *ngIf="section.SectionId == 2">
                                        <div class=" satisfactionLevel{{answer.Level}}">
                                            <div class="col-md-12">
                                                <div class="container-fluid">
                                                    <h4 style="margin-top: -5px;">Level {{answer.Level}}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>-->

                                    <div class="col-md-12" style="margin-bottom: 3px;">
                                        <div class="col-md-6" [ngClass]="{'negativelyKeyed': answer.NegativelyKeyed}">
                                            <p *ngIf="section.SectionId == 1"><b>{{answer.QuestionNumber}}</b>. {{answer.QuestionText}}</p>
                                            <p *ngIf="section.SectionId == 2"><b>{{answer.QuestionNumber}}</b>. {{answer.QuestionText}}</p>
                                        </div>
                                        <div class="col-md-6">
                                            <!--[style.width.%]="value"-->
                                            <div class="bar" style="min-width:20%;" [ngStyle]="{'width.%': answer.AnswerValue}">
                                                <span> {{answer.AnswerText}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--<div class="row">
                <div class="col-md-12">
                    <div class="col-md-6">
                        <p>1.  I feel guilty for things I've done.</p>
                    </div>
                    <div class="col-md-6">
                        <div class="bar percent0">
                            <span> Completely untrue</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-6">
                        <p>8.  I feel as though I have a constant weight on my shoulders.</p>
                    </div>
                    <div class="col-md-6">
                        <div class="bar percent50">
                            <span> Somewhat true</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-6">
                        <p>15. I get disappointed and upset when things don't go my way.</p>
                    </div>
                    <div class="col-md-6">
                        <div class="bar percent100">
                            <span> Completely true</span>
                        </div>
                    </div>
                </div>
            </div>-->
                        </div>
                    </div>

                    <div *ngIf="is360" id="Tab3" class="tab-pane fade" [ngClass]="{'in': !reportGenerated, 'active': !reportGenerated}">

                        <!--<div class="row">
                            <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                                <h1 class="h3 mb-0 text-gray-800"></h1>
                                <div class="btns-container">
                                    <a style="margin-right: 15px;" (click)="showNewRaterModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                        <i class="fas fa-save text-white-50"> <span class="button-text"> Add</span></i>
                                    </a>
                                </div>
                            </div>
                        </div>-->

                        <!--<div class="" style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #raterAgGrid
                                             style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             [gridOptions]="raterGridOptions"
                                             [rowData]="raters"
                                             [columnDefs]="raterHeaders"
                                             (rowClicked)="onRaterRowClicked($event)"
                                             (gridReady)="onRaterGridReadyModal($event)"
                                             [pagination]="true"
                                             [paginationPageSize]="25"
                                             [overlayNoRowsTemplate]="ratersOverlayNoRowsTemplate">
                            </ag-grid-angular>
                        </div>-->

                        <div class="row details" *ngFor="let rater of raters" title="{{getStatusLabel(rater.Status)}}">
                            <div class="col-xs-12 col-sm-4" style="padding-top:5px;">
                                <div>
                                    <p style="margin: 0px; white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;" title="{{rater.Email}}">{{rater.Email}}</p>
                                    <p>{{rater.FirstName}} {{rater.LastName}}</p>
                                    <p style="font-weight:bold;">{{rater.Relationship}}</p>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-8">
                                <div class="stepper">
                                    <div class="row line">
                                        <div class="stepLabel col-xs-4 stepText1">Invitation Sent</div>
                                        <div class="stepLabel col-xs-4 stepText2">In progress</div>
                                        <div class="stepLabel col-xs-4 stepText3">Completed</div>
                                    </div>
                                    <div [ngClass]="{'lineGreen0': rater.Status == '1', 'lineGreen50': rater.Status == '2', 'lineGreen100': rater.Status == '3'}"></div>
                                    <div class="row">
                                        <div class="col-xs-4">
                                        <div class="step step1" [ngClass]="{'steppCompleted': rater.Status == '3' || rater.Status == '2' || rater.Status == '1'}">
                                                <span>1</span>
                                             </div></div>

                                        <div class="col-xs-4">
                                            <div class="step step2" [ngClass]="{'steppCompleted': rater.Status == '3' || rater.Status == '2'}">
                                                <span>2</span>
                                             </div></div>

                                        <div class="col-xs-4">
                                            <div class="step step3" [ngClass]="{'steppCompleted': rater.Status == '3'}">
                                                <span>3</span>
                                             </div></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                    </div>

                    <div *ngIf="is360" id="Tab4" class="tab-pane fade">
                        <div style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #agGrid
                                             style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             [enableFilter]="true"
                                             [gridOptions]="assignmentRatersGridOptions"
                                             [rowData]="assignmentRaters"
                                             [columnDefs]="assignmentRatersHeaders"
                                             (gridReady)="onGridReady($event)"
                                             [pagination]="true"
                                             [paginationPageSize]="25"
                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate">
                            </ag-grid-angular>
                        </div>
                    </div>

                    <div *ngIf="is360" id="Tab5" class="tab-pane fade" style="max-height: 420px; overflow: auto;">
                        <ng-container *ngFor="let rater of ratersComments">
                            <div *ngIf="rater.Comment != ''" class="card"  style="margin-bottom:15px;"> 
                                <div class="card-body">
                                    <p>{{rater.RaterType}}</p>
                                    <i>{{rater.Comment}}</i>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div *ngIf="!reportGenerated" >
                        <a *ngIf="currentTabSelected == 2 || currentTabSelected == 3" (click)="showImportModal()" style="text-decoration:underline; cursor:pointer">Import</a>
                    </div>
                </div>                
            </div>
            </div>
        </div>
    </div>
</div>

<!--/*import modal*/-->
<div id="importRaterModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Import Raters</h2>
                <button type="button" class="close" (click)="closeImportModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div *ngIf="importRaterPageIdx == 0" class="row">
                    <div class="col-xs-3 col-sm-2 text-right">
                        <label><b style="color:#000;">File: </b></label>
                    </div>
                    <div class="col-xs-9 col-sm-10" style="display: inline-flex;">
                        <input type="text" class="input_readonly" style="cursor: default !important;" readonly [(ngModel)]="fileName" />
                        <div class="fileUpload btn btn-primary">
                            <span>...</span>
                            <input accept=".csv" (change)="getBlobFile($event)" type="file" class="upload" id="iFile" />
                        </div>
                    </div>
                </div>

                <div *ngIf="importRaterPageIdx == 1" class="row">
                    <div class="page2">
                        <h5>Language and Dates</h5>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Language: </label>
                            </div>
                            <div class="col-sm-12 col-md-9" style="padding-right: 5px;">
                                <select #importLanguage id="importLanguages">
                                    <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row radios">
                            <div class="col-sm-12 col-md-3 datepicker">
                                <label style="text-align: right;">Schedule for:</label>
                            </div>
                            <div class="col-sm-12 col-md-2" style="padding-right: 5px;" id="importDatapiker">

                                <label class="container">
                                    Now
                                    <input type="radio" checked="checked" name="schedule" value="0">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-4 responsiveRadioDiv" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                                <label class="container responsiveRadioLabel">
                                    <span style="margin-left:5px;"></span>
                                    <input type="radio" name="schedule" value="1">
                                    <span style="left: 18px;" class="checkmark"></span>
                                </label>
                                <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event)" [(ngModel)]="importDate" [settings]="settings"></angular2-date-picker> -->
                                <input type="date" [(ngModel)]="importDate" (change)="onDateSelect($event)">
                            </div>
                            <div class="col-sm-12 col-md-3" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                                <select (change)="importHourChanged()" class="blueSelect" id="importHour">
                                    <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                </select>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Expires in:</label>
                            </div>
                            <div class="col-sm-12 col-md-9">
                                <input id="importExpiresIn" type="number" name="text" value="30" max="30" min="0" />
                                <span>day(s)</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="row">
                        <div class="col-md-12">
                            <button *ngIf="importRaterPageIdx == 0" (click)="closeImportModal()" type="button" class="btn btn-secondary">Cancel</button>
                            <button *ngIf="importRaterPageIdx > 0" (click)="importRaterPrev()" type="button" class="btn btn-primary">Previous</button>
                            <button *ngIf="importRaterPageIdx < 1" style="margin-right: 25px;" (click)="importRaterNext()" type="button" class="btn btn-primary">Next</button>
                            <button *ngIf="importRaterPageIdx == 1" style="margin-right: 25px;" (click)="okImportRaters()" type="button" class="btn btn-primary">Finish</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION CHECK BOX*/-->
<div id="confirmationCheckModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Share results</h2>
                <button *ngIf="!loading" (click)="unCheck()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!loading; else showLoading" style="font-size:17px;">Please confirm you want to share the results with your client. Once confirmed they will be notifed through email. If you do not want your client to see the results in the future, please uncheck the box.</span>
                <ng-template #showLoading>
                    <div class="text-center">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 50px;"></i>
                        <p>Loading, please wait...</p>
                    </div>
                </ng-template>
            </div>

            <div class="modal-footer" *ngIf="!loading">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <button (click)="unCheck()" data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="confirmCheck()" type="button" class="btn btn-primary">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*GENERATE REPORT CONFIRMATION MODAL*/-->
<div id="confirmationGenerateReportModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Generate Results</h2>
                <button *ngIf="!loading" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span style="font-size:17px;">
                    Once the generation of your ELI 360 report is initiated, any additional responses not yet submitted at that time will be added to the online report in the order in which they are received. There will be no need to "add" future responses as they will be factored into the report when viewed by the Assessment Manager. If you would prefer to download the report to your device, a new report will need to be downloaded to capture the new responses.
                </span>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <button *ngIf="!generatingResults" (click)="unCheck()" data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button [disabled]="generatingResults" (click)="lockAssessment()" type="button" class="btn btn-primary">
                            <span *ngIf="!generatingResults; else spin">Confirm</span>
                            <ng-template #spin>
                               Generating <i style="position: relative;top: -3px;padding: 5px;" class="fas fa-spinner fa-spin"></i>
                            </ng-template>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--raters Modal-->
<app-raters-modal #ratersModal></app-raters-modal>
<app-reminder-email-modal #reminderModal [sendRemindEmail]="sendReminderEmails"></app-reminder-email-modal>